import { render, staticRenderFns } from "./EditProvision.vue?vue&type=template&id=61d0c586&scoped=true&"
import script from "./EditProvision.vue?vue&type=script&lang=js&"
export * from "./EditProvision.vue?vue&type=script&lang=js&"
import style0 from "./EditProvision.vue?vue&type=style&index=0&id=61d0c586&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d0c586",
  null
  
)

export default component.exports